module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/setouchi_prize-1a8ca55461083105c89f52d4b3b4a3f4.jpg";